module.exports = __webpack_public_path__ + "bde7135b2c33a00489c97ca7a49b32ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/amazon_com_2023_chart.png
// module id = 1631
// module chunks = 0